import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "data-name": "Контур 335945",
      d: "M11.293.3a.976.976 0 0 1 1.414 0L24 12 12.707 23.7a.976.976 0 0 1-1.414 0L0 12Z",
      fill: "#2159f6"
    }, null, -1)
  ]))]))
}
export default { render: render }